import { useUser } from '@charlava-com/auth';

/** Friendly name for the signed-in user; the email's local part is the last resort. */
export function useDisplayName(): string | undefined {
  const [userState] = useUser();
  const profile = userState?.data as Record<string, unknown> | undefined;
  const name = [
    profile?.given_name,
    profile?.name,
    profile?.preferred_username,
  ].find(
    (value): value is string => typeof value === 'string' && !!value.trim()
  );
  if (name) return name.trim();
  const email = profile?.email;
  return typeof email === 'string' && email.includes('@')
    ? email.split('@')[0]
    : undefined;
}
